import B2BDivider from './b2b-divider.component'

export default B2BDivider
